// src/mocks/handlers/funding/invoicesCollectionsDetailsHandler.ts

import { rest } from 'msw';
import invoicesCollectionsDetails from '@/mocks/data/fundingCollectionDetailsData.json';
import { API_ENDPOINTS } from '@/services/api/endpoints';
import { VITE_API_BASE_URL } from '@/config';
import {
  IInvoicesCollectionsDetails,
  IInvoicesCollectionsDetailsResponse,
} from '@/domains/funding/invoices.types';
import { isAccessTokenExpired } from '@/mocks/lib/authTokenUtils';

export const fundingInvoicesCollectionsDetailsHandler =
  rest.get<IInvoicesCollectionsDetailsResponse>(
    `${VITE_API_BASE_URL}${API_ENDPOINTS.FUNDING_INVOICES_COLLECTIONS}`,
    (req, res, ctx) => {
      const token = req.headers.get('Authorization');
      if (!token) {
        return res(
          ctx.status(500),
          ctx.json({ detail: 'Something went wrong' }),
        );
      }

      if (isAccessTokenExpired()) {
        return res(
          ctx.status(401),
          ctx.json({ error: 'Access token expired' }),
        );
      }

      const { invoice_uuid } = req.params as { invoice_uuid: string };

      // Mock response data
      const mockResponse = invoicesCollectionsDetails
        .find((invoice) => invoice.uuid === invoice_uuid)
        ?.collections.map((collection) => ({
          collection_date: collection.collection_date,
          collected: collection.collected,
          payment_id: collection.payment_id,
          payment_ref: collection.payment_ref,
        })) as IInvoicesCollectionsDetails | undefined;

      if (!mockResponse) {
        return res(
          ctx.status(404),
          ctx.json({ detail: 'Invoice collections details not found' }),
        );
      }

      // Return the mock response
      return res(ctx.status(200), ctx.json({ collections: mockResponse }));
    },
  );
